import { createContext } from "react";
import { MonetaryAmount } from "../../../../../app/domain/monetary-amount";
import recurrentPaymentsContextInterface from "./types";

const RecurrentPaymentContext =
  createContext<recurrentPaymentsContextInterface>({
    recurrentPayments: [],
    recurrentPaymentDetail: null,
    isLoading: false,
    initialLoad: false,
    setRecurrentPayments: () => {},
    setIsLoading: () => {},
    setInitialLoad: () => {},
    loadRecurrentPayments: () => {},
    loadRecurrentPaymentDetail: () => {},
    totalItems: 0,
    setTotalItems: () => {},
    setRecurrentPaymentDetail: () => {},
    rentingDetails: {
      VATSupportedBy: "",
      amountPerPayment: MonetaryAmount.ZERO,
      energyEfficiency: 0,
      firstPaymentAmount: MonetaryAmount.ZERO,
      firstPaymentOriginalAmount: MonetaryAmount.ZERO,
      firstPaymentTimestamp: 0,
      initialPaymentByCompany: MonetaryAmount.ZERO,
      initialPaymentByEmployee: MonetaryAmount.ZERO,
      lastPaymentTimestamp: 0,
      monthlyAttribution: MonetaryAmount.ZERO,
      numberOfPayments: 0,
      originalAmountPerPayment: MonetaryAmount.ZERO,
      privateUseRatio: 0,
      rentingCostPerPaymentCompany: MonetaryAmount.ZERO,
      rentingCostPerPaymentEmployee: MonetaryAmount.ZERO,
      serviceStartTimestamp: 0,
      totalAmount: MonetaryAmount.ZERO,
      vehiclePrice: MonetaryAmount.ZERO,
      yearlyAttribution: MonetaryAmount.ZERO,
    },
    setRentingDetails: () => {},
    rentingInitialData: null,
    setRentingInitialData: () => {},
  });

export default RecurrentPaymentContext;
